// Save data to localStorage
export function saveToStorage (key, value) {
  if (typeof window !== 'undefined') {
    try {
      localStorage.setItem(
        key,
        typeof value !== 'string' ? JSON.stringify(value) : value
      )
      console.log(`Saved ${key} to localStorage`)
    } catch (e) {
      // handle error if needed
    }
  }
}

// Get data from localStorage
export function getFromStorage (key) {
  if (typeof window !== 'undefined') {
    try {
      const value = localStorage.getItem(key)
      return value ? JSON.parse(value) : null
    } catch (e) {
      // handle error if needed
      return null
    }
  }
  return null
}

// Remove data from localStorage
export function removeFromStorage (key) {
  if (typeof window !== 'undefined') {
    try {
      localStorage.removeItem(key)
    } catch (e) {
      // handle error if needed
    }
  }
}

// Helper functions for previous locations

export const getLastLocation = async () => {
  const mylatitude = getFromStorage('mylatitude')
  const mylongitude = getFromStorage('mylongitude')
  let lastUserLoc = null
  const previousLocs = await getMyPreviousLocs()

  if (mylatitude && mylongitude) {
    lastUserLoc = { latitude: mylatitude, longitude: mylongitude }
  }

  if (previousLocs.length > 0) {
    return previousLocs[0]
  } else if (lastUserLoc) {
    return lastUserLoc
  } else {
    return null
  }
}

export const getMyPreviousLocs = () => {
  const locs = getFromStorage('mypreviousbookinglocations')
  return Array.isArray(locs) ? locs : []
}

export const addMyPreviousLocs = async location => {
  let locs = await getMyPreviousLocs()

  locs = locs.filter(
    loc =>
      !(
        loc.latitude == location.latitude && loc.longitude == location.longitude
      )
  )

  locs.unshift(location)
  locs = locs.slice(0, 10)

  saveToStorage('mypreviousbookinglocations', locs)
}
